export default __webpack_public_path__ + "static/media/charge_point_map.8305b7a2.svg";